import React from 'react';
import { Form, App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { CONTRACTOR_CREATE } from '../../../graphql/mutations/contractors';
import { ContractorForm } from '../../../components/Contractor/ContractorForm';
import CardLayout from '../../../layouts/CardLayout';
import { IContractorPhoto, ContractorFormValues } from '../../../types/contractor';

const ContractorCreate: React.FC = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [createContractor, { loading }] = useMutation(CONTRACTOR_CREATE, {
    onCompleted: data => {
      message.success('Contractor successfully created');
      navigate(`/admin/contractor/${data.contractorCreate.id}`);
    },
    onError: error => {
      message.error(error.message);
    },
  });

  const onFinish = async (values: ContractorFormValues) => {
    try {
      const photos = values.photos?.map((photo: IContractorPhoto) => photo.url);
      const logo = (Array.isArray(values.logo) && values.logo[0]?.url) || '';

      await createContractor({
        variables: {
          ...values,
          photos,
          logo,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CardLayout>
      <ContractorForm
        form={form}
        onFinish={onFinish}
        loading={loading}
        submitText="Create Contractor"
      />
    </CardLayout>
  );
};

export default ContractorCreate;
